import { Icon } from '../../../../icon/Icon';

export function FieldsConfigSourceDestTableNameView({
  sourceTableName,
  destinationTableName
}: {
  sourceTableName: string;
  destinationTableName: string;
}) {
  return (
    <div className='center-flex-row w-100'>
      <div style={{ maxWidth: '50%' }}>
        <div className='text-caption-1 text-secondary text-uppercase'>Source Object</div>
        <div className='text-body-2 text-ellipsis'>{sourceTableName}</div>
      </div>

      <Icon className='mx-4' name='add-arrow-right' />

      <div style={{ maxWidth: '50%' }}>
        <div className='text-caption-1 text-secondary text-uppercase'>Destination Object</div>
        <div className='text-body-2 text-ellipsis'>{destinationTableName}</div>
      </div>
    </div>
  );
}
